import type { EquipmentRef, LastReading } from '../api/types';
import { type ScheduleState } from '../lib/schedule';
import { statusUi, ago } from '../lib/statusUi';
import { fmtTime } from '../lib/format';

/** Operator status "hero" — one glance tells you: which equipment, can I log, is it due. */
export default function StatusCard(props: {
  equipment: EquipmentRef;
  schedule: ScheduleState;
  lastReading: LastReading | null;
  tz?: string;
}) {
  const { equipment, schedule, lastReading, tz } = props;
  const ui = statusUi(schedule.status);

  return (
    <div className="hero">
      <div className={`hero-band ${ui.tone}`} />
      <div className="hero-body">
        <h1>{equipment.name}</h1>
        <div className="hero-loc">{equipment.location} · <span style={{ color: 'var(--ok)' }}>✓ NFC verified</span></div>

        <div className={`hero-status ${ui.tone}`}>
          <span className="dot" />
          {ui.headline}
        </div>

        <div className="hero-sub">
          {lastReading
            ? <>Last reading {ago(lastReading.effectiveReadingAt)}{lastReading.operatorName ? `, by ${lastReading.operatorName}` : ''}</>
            : 'No readings recorded yet'}
          {schedule.status !== 'BLOCKED' && schedule.nextRecommendedAt &&
            <> · next due {fmtTime(schedule.nextRecommendedAt, tz)}</>}
        </div>
      </div>
    </div>
  );
}
